import React from 'react'
import { Text } from '../Text'
import { IProps } from './index'

export const FooterHeadingLink = ({ text, url }: IProps): React.ReactElement => {
  return (
    <>
      <a href={url} className="footer__link">
        <p>
          <Text brand="default" size="button-bold">
            {text}
          </Text>
        </p>
      </a>
    </>
  )
}
